import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
import { initializeApp } from "firebase/app";
// import { getServiceWorkerRegistration } from "@/main";
import API from "@/shared/API";
import apiEndpoints from "@/util/apiEndpoints";
import axios from "axios";

let vapidKey = null;
let firebaseConfig = {};
let messaging = null;
let tokenCheckInterval = null;
const TOKEN_STORAGE_KEY = "fcmToken";

async function getFirebaseConfig()  {
    try {
        const res = await axios.get(apiEndpoints.getFirebaseConfig).catch(function(error){
            console.log('Error', error.message);
        });
        const config = res.data;
        firebaseConfig = {
            apiKey: config.apiKey,
            authDomain: config.authDomain,
            projectId: config.projectId,
            messagingSenderId: config.messagingSenderId,
            appId: config.appId
        };
        vapidKey = config.vapidKey;
    } catch (err) {
        console.error("Failed to load Firebase config:", err);
    }
}

export async function initFirebaseMessaging() {
    await getFirebaseConfig();
    const app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
}

export async function registerFcm(user) {
  console.log("🚀 registerFcm started", { role: user?.role });

  // Ensure user is logged in
  if (!user || (user.role != "R" && user.role != "T")) {
    console.warn("registerFcm: invalid user or role", user);
    return;
  }

  const permission = await Notification.requestPermission();
  console.log("Permission result:", permission);
  if (permission !== "granted") {
    console.warn("Notifications not allowed");
    return null;
  }

  if (!messaging) {
    console.error("Firebase not initialized — messaging is null");
  }

  console.log("Getting FCM token...");
  try {
    const token = await getToken(messaging, {
      vapidKey: vapidKey,
      serviceWorkerRegistration: await navigator.serviceWorker.getRegistration(),
    });

    console.log("FCM token received:", token ? "✅ token exists" : "token is null");

    if (token) {
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
      const payload = { deviceToken: token };
      console.log("📤 Sending token to backend...");
      await sendTokenToBackend(payload);
      console.log("✅ Token sent to backend successfully");
    }
  } catch (err) {
    console.error("Error in registerFcm:", err.message, err);
  }
}

export async function unregisterFcmToken(role) {
  if (!role || (role != "R" && role != "T")) return;
  console.log("role is ", role);
  try {
        const token = localStorage.getItem(TOKEN_STORAGE_KEY)
        if (token) {
            await removeDeviceToken(token);
            stopDailyTokenRefresh();
        }
    } catch (e) {
        console.log("Couldn't remove Firebase token: ", e);
    }
}

async function sendTokenToBackend(data){
    const logDeviceTokenUrl = `${apiEndpoints.logDeviceToken}`;
    await API.post(logDeviceTokenUrl, data).catch(function (error) {
        console.log('Error save log event', error.message);
    });
}

async function removeDeviceToken(fcmToken) {
  try {
    let removeDeviceTokenUrl = "/user/removeDeviceToken";
    const response = await fetch(removeDeviceTokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ fcmToken })
    });

    if (!response.ok) {
      throw new Error('Failed to remove device token');
    }

    console.log('Device token removed successfully before logout.');
  } catch (error) {
    console.error('Error removing device token:', error);
  }
}

// The function that checks & refreshes token
async function checkAndRefreshToken() {
    if (!messaging) return null;
    let user = localStorage.subjectId;
    const savedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (!user) return null;
    const token = await getToken(messaging, {
        vapidKey: vapidKey,
        serviceWorkerRegistration: await navigator.serviceWorker.getRegistration()
    });
    if (token !== savedToken) {
        localStorage.setItem(TOKEN_STORAGE_KEY, token);
        const payload = {oldToken: savedToken, newToken: token};
        await updateLogDeviceToken(payload)
        console.log(payload)
    } else {
        console.log("✅ Token still valid");
    }
}

async function updateLogDeviceToken(data){
    const updateLogDeviceTokenUrl = `${apiEndpoints.updateLogDeviceToken}`;
    await API.post(updateLogDeviceTokenUrl, data).catch(function (error) {
        console.log('Error save log event', error.message);
    });
}

export async function dailyFCMTokenCheck() {
    if (tokenCheckInterval) {
        clearInterval(tokenCheckInterval);
    }
    // Then check every 24 hours
    tokenCheckInterval = setInterval(async () => {
        console.log("🔍 Daily FCM token check...");
        await checkAndRefreshToken();
    }, 24 * 60 * 60 * 1000);

    console.log("⏰ Daily token refresh scheduler started");
}

function stopDailyTokenRefresh() {
    if (tokenCheckInterval) {
        clearInterval(tokenCheckInterval);
        tokenCheckInterval = null;
        console.log("🛑 Daily token refresh scheduler stopped");
    }
}

export function initForegroundMessages() {
    const messaging = getMessaging();

    onMessage(messaging, (payload) => {
        console.log("💬 Foreground message received:", payload);

        window.dispatchEvent(new CustomEvent('firebase-message', { detail: payload }));
    });
}

export async function deleteFCMToken() {
  try {
    if(messaging){
      await deleteToken(messaging);
    }
  } catch (error) {
    console.warn("Could not delete existing token:", error);
  }
}
